module.exports = function (options) {
  return INKIVE.C.IS_MOBILE
    ? options.inverse(this)
    : options.fn(this);
};
